// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"16":"1680ae43","28":"22758047","231":"7dc01656","726":"5cd10a5d","788":"c7b8d1b9"}[chunkId] + ".js";
};